import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import TableSettingsListItem from './TableSettingsListItem';
export const TableSettingsListContainer = (props) => {
    const { items, itemProps, onSortEnd } = props;
    const [activeDraggedColumn, setActiveDraggedColumn] = useState(null);
    const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }));
    const handleDragStart = useCallback((event) => {
        setActiveDraggedColumn(event.active.id);
    }, []);
    const handleDragEnd = (event) => {
        setActiveDraggedColumn(null);
        onSortEnd(event, items);
    };
    const activeClass = 'table-settings-item shadow-smooth-to-bottom z-index-max';
    return (_jsx("div", Object.assign({ className: 'table-settings-items-container' }, { children: _jsx(DndContext, Object.assign({ sensors: sensors, collisionDetection: closestCenter, modifiers: [restrictToVerticalAxis], onDragStart: handleDragStart, onDragEnd: handleDragEnd }, { children: _jsx(SortableContext, Object.assign({ items: items, strategy: verticalListSortingStrategy }, { children: items.map((column, index) => (_jsx(TableSettingsListItem, Object.assign({ column: column, orderIndex: index, isActive: activeDraggedColumn === column, className: activeDraggedColumn === column ? activeClass : '' }, itemProps), column))) })) })) })));
};
